import { createMasterScreen } from '../../../components/erp/ERPMasterScreenFactory';
export default createMasterScreen({
  title: 'Size Master', screenId: '4.3.7', module: 'Procurement', apiPath: 'size', screenName: 'SizeMaster', idField: 'SizeId', nameField: 'SizeOfDress',
  gridColumns: [{ field: 'SizeId', header: 'Size ID' }, { field: 'SizeOfDress', header: 'Size Name' }],
  formFields: [{ field: 'SizeId', label: 'Size Id', disabled: true }, { field: 'SizeOfDress', label: 'Size Name', required: true }]
});
